import { PropsWithChildren } from 'react';
import cls from './form-modal.module.css';

type ModalSize = "default" | "large" | "extra-large"

export interface FormModalProps {
	onClose: () => void
	size?: ModalSize
	showModal?: boolean;
	title?: string
}

function FormModal(props: PropsWithChildren<FormModalProps>) {
	const modalSize = props.size === "large"
		? cls.modalContentLarge
		: cls.modalContent;

	return (
		<div className={cls.modal}>
			<div className={modalSize}>
				<div className={cls.modalHeader}>
					{props.title && <h5>{props.title}</h5>}
					<button title='Close Modal' type='button'
						className={"btn btn-close"}
						onClick={() => props.onClose?.()}>
					</button>
				</div>
				<div className={cls.modalBody}>
					{props.children}
				</div>
			</div>
		</div>
	);
}

export default FormModal;